/**
 * evaluateParamValue
 */

export const evaluateParamValue = <T,>(param: T | undefined | null, defaultValue: T | undefined | null): T | null => {
  if (param === undefined) return defaultValue ?? null;
  return param;
}